// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__QDH7Q","s4":"loader_s4__RAOBD"};